<template>
  <div class="p-6 bg-white rounded-xl shadow-md">
    <h3 class="text-xl font-bold text-purple-600 inline-block transition-all duration-500">
      <span
          class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
        سفارش های جاری  (کل ایران)
      <span v-if="filters.date"> {{filters.date.split('-').reverse().join('-')}} </span>
      </span>
      <span
          class="mr-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-900 via-pink-900 to-blue-900 hover:animate-pulse">
        <span class="text-[8px] text-gray-500">تعداد </span>
            {{ totalCount }}
            <span class="text-[8px] text-gray-500">سفارش</span>
      </span>
    </h3>
    <div class="mt-2 flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
      <div class="flex flex-wrap gap-2">
        <input v-model="filters.id" @input="fetchOrders(1)" type="number"
               placeholder="شماره سفارش"
               class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right">


        <div class="w-48">
          <select
              @change="fetchOrders(1)"
              id="printStatus"
              v-model="filters.is_printed"
              class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right">
          >
            <option value="all">وضعیت چاپ (همه)</option>
            <option value="true">چاپ شده</option>
            <option value="false">چاپ نشده</option>
          </select>
        </div>

        <div class="w-48">
          <select
              @change="fetchOrders(1)"
              id="torobFilter"
              v-model="filters.is_torob"
              class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right">
          >
            <option value="all">منبع سفارش (همه)</option>
            <option value="true">فقط ترب</option>
            <option value="false">بدون ترب</option>
          </select>
        </div>


        <date-field class="px-3 py-2 bg-gray-100 text-sm rounded-lg border w-40 text-right" placeholder=" تاریخ"
                    v-model="filters.date" @input="fetchOrders(1)"></date-field>

        <button
            @click="resetFilters"
            class="p-3 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
            title="حذف فیلترها"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>


      <div>
        <div v-if="printPopup" class="fixed inset-0 z-50 flex items-center justify-center">
          <div
              class="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm"
          ></div>

          <div class=" text-center relative bg-white/90 p-6 rounded-xl shadow-2xl border border-white/20 max-w-2xl w-full mx-4">
            <h3 v-if="!wait_for_submit" class="text-lg font-bold mb-6 text-gray-800">پرینت فاکتور ها برای بسته بندی</h3>
            <h3 v-if="wait_for_submit" class="text-lg font-bold mb-6 text-gray-800">تایید ارسال سفارشات</h3>

            <p v-if="!wait_for_submit"  class="mb-3 text-gray-700">
              شما در حال پرینت فاکتور  {{ orders.length }} سفارش هستید
            </p>
            <p v-if="!wait_for_submit"  class="mb-3 text-gray-700">
               لطفا برای ادامه مسئول بسته‌بندی این فاکتور هارو مشخص کنید
            </p>

            <user-select
                :disabled="wait_for_submit"
                user-type="paad"
                class="rounded-lg mb-2"
                placeholder=" انتخاب مسئول بسته‌بندی"
                v-model="packing_admin"
            >
            </user-select>

            <p v-if="packing_admin != null && !wait_for_submit"  class="mb-3 mt-2 text-purple-500 animate-pulse font-weight-bold text-h6">این عملیات در تاریخچه ثبت خواهد شد و قابل بازگشت نیست</p>
            <p v-if="packing_admin != null && !wait_for_submit"  class=" text-gray-700">آیا ادامه می‌دهید؟</p>
            <p v-if="wait_for_submit" class="mb-3 text-purple-500 animate-pulse font-weight-bold text-md">این عملیات قابل بازگشت نیست از پرینت فاکتور ها اطمینان داشته باشید</p>
            <p v-if="wait_for_submit" class="mb-3 text-gray-700">آیا از تغییر وضعیت  {{orders.length}} سفارش به «در حال بسته بندی» اطمینان دارید؟</p>

            <div class="flex justify-end gap-3">
              <button
                  @click="cancel"
                  class="px-4 py-2 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-100 transition text-gray-700"
              >
                انصراف
              </button>
              <button
                  v-if="packing_admin != null && !wait_for_submit"
                  @click="confirmPrint"
                  class="px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-lg hover:shadow-md transition-all hover:scale-[1.02]"
              >
                پرینت
              </button>
              <button
                  v-if="wait_for_submit"
                  @click="confirmAction"
                  class="px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-lg hover:shadow-md transition-all hover:scale-[1.02]"
              >
                تایید درحال بسته بندی
              </button>
            </div>
          </div>
        </div>

        <button
            @click="printConfirmation"
            class="bg-purple-500 hover:bg-purple-700 text-white px-4 py-2 rounded-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-blue-500 hover:shadow-md hover:animate-pulse"
        >
          پرینت فاکتور ها برای بسته بندی
        </button>
      </div>

      <div>
        <div v-if="showPopup" class="fixed inset-0 z-50 flex items-center justify-center">
          <div
              @click="showPopup = false"
              class="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm"
          ></div>

          <div class=" relative bg-white/90 p-6 rounded-xl shadow-2xl border border-white/20 max-w-xl w-full mx-4">
            <h3 class="text-lg font-bold mb-6 text-gray-800">تایید ارسال سفارشات</h3>
            <p class="mb-3 text-gray-700">آیا از تغییر وضعیت  {{orders.length}} سفارش به «ارسال شده» اطمینان دارید؟</p>
            <p class="mb-3 text-purple-500 animate-pulse font-weight-bold text-md">این عملیات قابل بازگشت نیست از پرینت فاکتور ها اطمینان داشته باشید</p>
            <p class=" text-gray-700">آیا مطمئن هستید که می‌خواهید ادامه دهید؟</p>

            <div class="flex justify-end gap-3">
              <button
                  @click="showPopup = false"
                  class="px-4 py-2 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-100 transition text-gray-700"
              >
                انصراف
              </button>
              <button
                  @click="confirmAction"
                  class="px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-lg hover:shadow-md transition-all hover:scale-[1.02]"
              >
                تایید ارسال سفارشات
              </button>
            </div>
          </div>
        </div>
        <!--
        <button
            @click="showConfirmation"
            class="bg-purple-500 hover:bg-purple-700 text-white px-4 py-2 rounded-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-gradient-to-r hover:from-purple-500 hover:via-pink-500 hover:to-blue-500 hover:shadow-md hover:animate-pulse"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          تایید ارسال سفارشات
        </button>
        -->
      </div>

    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full table-auto text-right border border-gray-200">
        <thead class="bg-gray-50 text-sm text-gray-700">
        <tr>
          <th class="p-3 border text-[9px]">ردیف</th>
          <th class="text-center p-3 border text-[9px]">شماره سفارش</th>
          <th class="text-center p-3 border text-[9px]">تاریخ</th>
          <th class="text-center p-3 border text-[9px]">کد رهگیری اکسونی</th>
          <th class="text-center p-3 border text-[9px]">وضعیت</th>
          <th class="text-center p-3 border text-[9px]">تعداد اقلام</th>
          <th class="text-center p-3 border text-[9px]">مبلغ سفارش</th>
          <th class="text-center p-3 border text-[9px]">هزینه ارسال</th>
          <th class="text-center p-3 border text-[9px]">مبلغ تخفیف</th>
          <th class="text-center p-3 border text-[9px]">مبلغ کل</th>
          <th class="text-center p-3 border text-[9px]">مشتری</th>
          <th class="text-center p-3 border text-[9px]">نوع پرداخت</th>
          <th class="text-center p-3 border text-[9px]"></th>
        </tr>
        </thead>
        <tbody class="text-gray-600 text-sm">
        <tr v-for="order in orders" :key="order.id"
            class="cursor-pointer hover:bg-gray-50 transition"
            @click="$router.push(`/panel/adminOrderDetail/${order.id}`)">
          <td class="text-center p-2 border">{{ orders.indexOf(order) + 1 }}</td>
          <td class="text-center p-2 border">{{ order.id }}</td>
          <td class="text-center p-2 border text-[9px]">{{ formatDate(order.date_time) }}</td>
          <td class="text-center p-2 border text-[10px]">{{ order.exuni_tracking_code }}</td>
          <td class="text-center p-2 border">
            <span :class="statusClass(order.status)">
              {{ statusLabels[order.status] || order.status }}
            </span>
          </td>
          <td class="p-2 border text-center">{{ order.total_product_quantity | toMoney }}
            <span class="text-center text-[8px] text-gray-500">عدد</span>
          </td>
          <td class="text-center p-2 border">{{ order.total_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class=" text-center p-2 border">{{ order.post_price | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">{{ order.total_discount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">{{ order.final_amount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">
            <span class="text-[12px]">{{order.customer.mobile_number}}</span>
            <span class="m-1 mr-1 text-[8px] text-gray-500">{{order.shipment_address.first_name}}</span>
            <span class="text-[8px] text-gray-500">{{order.shipment_address.last_name}}</span>
          </td>
          <td class="p-2 border text-[10px]">{{ order.payment_display }}</td>
          <td class="p-2 border text-[10px]">
            <div class="relative flex items-center justify-center group">
              <template v-if="order.is_printed">
                <!-- Green printer with checkmark (RTL aligned) -->
                <span class="flex items-center text-green-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
      </span>
                <span
                    class="absolute z-10 hidden group-hover:block left-full top-1/2 transform -translate-y-1/2 mr-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap">
        چاپ شده توسط {{ order.printed_user }}
      </span>
              </template>
              <template v-else>
                <!-- Red printer with clock (RTL aligned) -->
                <span class="flex items-center text-red-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </span>
                <span
                    class="absolute z-10 hidden group-hover:block left-full top-1/2 transform -translate-y-1/2 mr-2 px-2 py-1 text-xs text-white bg-gray-800 rounded whitespace-nowrap">
        هنوز چاپ نشده است
      </span>
              </template>
            </div>
          </td>

        </tr>


        <!-- Totals Row -->
        <tr class="bg-gray-100 font-bold text-gray-800">
          <td class="text-center p-2 border">
            {{ orders.length }}
            <span class="text-[8px] text-gray-500">سفارش</span>
          </td>
          <td class="text-center p-2 border" colspan="4">جمع کل</td>
          <td class="text-center p-2 border">
            {{ totals.total_product_quantity }}
            <span class=" text-center text-[8px] text-gray-500">عدد</span>
          </td>
          <td class="text-center p-2 border">
            {{ totals.total_price | toMoney }}
            <span class="text-center text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">
            {{ totals.post_price | toMoney }}
            <span class="text-center text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">
            {{ totals.total_discount | toMoney }}
            <span class="text-center text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border">
            {{ totals.final_amount | toMoney }}
            <span class="text-[8px] text-gray-500">تومان</span>
          </td>
          <td class="text-center p-2 border" colspan="3"></td>
        </tr>

        </tbody>
      </table>

      <div class="flex items-center justify-between mt-4 space-x-2 ">
        <div class="flex items-center gap-1">
          <label class="text-sm text-white bg-primary rounded pa-1">فاکتور در هر صفحه:
            <input
                v-model.number="perPage"
                type="number"
                placeholder="تعداد"
                class="bg-gray-100 text-gray-700 text-sm rounded border w-18 my-1 mx-1 px-[0.5] py-[0.5] text-center"
            />
          </label>
        </div>

        <div class="flex gap-1">
          <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="text-sm border rounded p-1 text-blue-100 bg-blue-700 hover:bg-gray-900 cursor-pointer disabled:opacity-50"
          >
            صفحه قبل
          </button>
          <span class=" px-2 py-1 text-sm text-white bg-primary rounded pa-1">صفحه {{ currentPage }}</span>
          <button
              @click="nextPage"
              :disabled="(currentPage * perPage) >= totalCount"
              class="text-sm border rounded p-1 text-blue-100 bg-blue-700 hover:bg-gray-900 cursor-pointer disabled:opacity-50"
          >
            صفحه بعد
          </button>
        </div>
      </div>


    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-full max-w-xs text-gray-500 bg-white rounded-lg shadow-lg border border-gray-200"
           :class="{
             '!bg-green-50 !border-green-200 !text-green-700': notificationType === 'success',
             '!bg-red-50 !border-red-200 !text-red-700': notificationType === 'error'
           }">
        <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg"
             :class="{
               'text-green-500 bg-green-100': notificationType === 'success',
               'text-red-500 bg-red-100': notificationType === 'error'
             }">
          <svg v-if="notificationType === 'success'" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
          <svg v-else class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </div>
        <div class="mr-3 text-sm font-normal pr-2">{{ notificationMessage }}</div>
        <button @click="showNotification = false" class="mr-auto text-gray-400 hover:text-gray-900 rounded-lg p-1.5 hover:bg-gray-100">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>
    <div class="p-6 bg-white rounded-xl shadow-md relative">
      <div v-if="isLoading" class="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center z-50 rounded-xl">
        <div class="text-center">
          <svg class="animate-spin h-12 w-12 text-purple-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <p class="mt-2 text-purple-600">در حال بارگذاری...</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DateField from "@/components/mcomponents/cleave/DateField";
import UserSelect from "@/components/selects/UserSelect";

export default {
  name: 'AdminPaidOrders',
  components: {UserSelect, DateField},
  data() {
    return {
      packing_admin: null,
      wait_for_submit: false,
      currentPage: 1,
      perPage: 50,
      totalCount: 0,
      showNotification: false,
      printPopup: false,
      showPrintPopup: false,
      notificationMessage: '',
      notificationType: 'success',
      showPopup: false,
      orders: [],
      selected: [],
      isLoading: false,
      selectAll: false,
      filters: {
        id: '',
        is_printed: 'all',
        is_torob: 'all',
        date: '',
      },
      statusLabels: {
        pe: "در انتظار پرداخت",
        pa: "جاری",
        pr: "درحال بسته بندی",
        pc: "بسته بندی شد",
        sh: "ارسال شده",
        de: "تحویل شده",
        ca: "لغو شده",
        re: "مرجوعی"
      },
      quickDateLAbles: {
        today: "امروز",
        yesterday: "دیروز",
        this_month: "این ماه",
      },
    };
  },
  computed: {
    toId() {
      if (this.orders.length === 0) return ''
      return this.orders[0].id
    },
    fromId() {
      if (this.orders.length === 0) return ''
      return this.orders[this.orders.length - 1].id
    },
    filteredOrders() {

      return this.orders
    },
    totals() {
      return this.filteredOrders.reduce(
          (sum, order) => {
            sum.total_product_quantity += Number(order.total_product_quantity || 0);
            sum.total_price += Number(order.total_price || 0);
            sum.post_price += Number(order.post_price || 0);
            sum.total_discount += Number(order.total_discount || 0);
            sum.final_amount += Number(order.final_amount || 0);
            return sum;
          },
          {
            total_product_quantity: 0,
            total_price: 0,
            post_price: 0,
            total_discount: 0,
            final_amount: 0,
          }
      );
    }
  },
  watch: {
    perPage() {
      this.fetchOrders(1)
    }
  },
  methods: {
    resetFilters() {
      this.filters = {
        id: '',
        date: '',
        is_printed: 'all',
        is_torob: 'all',
      }
      this.packing_admin = null
      this.wait_for_submit = false
      this.fetchOrders(1)
    },

    nextPage() {
      if ((this.currentPage * this.perPage) < this.totalCount) {
        this.fetchOrders(this.currentPage + 1)
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.fetchOrders(this.currentPage - 1)
      }
    },

    printConfirmation() {
      this.printPopup = true;
    },
    confirmPrint() {
      this.wait_for_submit = true;
      this.printOrdersToPacking();
    },
    printOrdersToPacking() {
      const params = {
        status: 'pa',
        to_id: this.toId,
        from_id: this.fromId,
        admin: this.packing_admin,
        token: this.token,
      }
      if (this.filters.is_printed !== 'all') {
        params.is_printed = this.filters.is_printed
      }

      if (this.filters.is_torob !== 'all') {
        params.is_torob = this.filters.is_torob
      }

      if (this.filters.id) {
        params.id = this.filters.id
      }

      if (this.filters.date) {
        params.date = this.filters.date
      }

      const queryString = new URLSearchParams(params).toString()
      const print_url = `https://api.exuni.ir/shop/adminOrdersExport/html?${queryString}`

      window.open(print_url)
      setTimeout(() => {
        this.fetchOrders(this.currentPage)

      }, 1000);
    },

    showNotificationMessage(message, type = 'success') {
      this.notificationMessage = message;
      this.notificationType = type;
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    fetchOrders(page = 1) {
      this.isLoading = true
      const offset = (page - 1) * this.perPage
      const params = {
        limit: this.perPage,
        offset: offset || 0,
      }
      if (this.filters.is_printed !== 'all') {
        params.is_printed = this.filters.is_printed
      }
      if (this.filters.is_torob !== 'all') {
        params.is_torob = this.filters.is_torob
      }
      if (this.filters.id) {
        params.id = this.filters.id
      }
      if (this.filters.date) {
        params.date = this.filters.date
      }
      let fetch_url = `shop/paidShopOrderList/all`

      this.request({
        url: this.endpoint(fetch_url),
        params: params,
        method: "get",
        success: data => {
          this.isLoading = false
          this.orders = data.results
          this.totalCount = data.count
          this.currentPage = page
        }
      })
    },
    toggleSelectAll() {
      this.selected = this.selectAll ? this.filteredOrders.map(o => o.id) : [];
    },
    statusClass(status) {
      console.log(status)
      const map = {
        pe: "  text-yellow-600 bg-yellow-100 px-2 py-1 rounded-full text-[9px]",
        pa: "  text-green-600 bg-green-100  px-2 py-1 rounded-full text-[9px]",
        pr: "  text-blue-600 bg-blue-100 px-2 py-1 rounded-full text-[9px]",
        pc: "  text-indigo-800 bg-indigo-200 px-2 py-1 rounded-full text-[9px]",
        sh: "  text-purple-600 bg-purple-100 px-2 py-1 rounded-full text-[9px]",
        de: "  text-green-600 bg-green-100 px-2 py-1 rounded-full text-[9px]",
        ca: "  text-red-600 bg-red-100 px-2 py-1 rounded-full text-[9px]",
        re: "  text-gray-600 bg-gray-100 px-2 py-1 rounded-full text-[9px]",
      };
      return map[status] || "bg-gray-200 text-gray-700 px-2 py-1 rounded-full text-[9px]";
    },
    formatDate(date) {
      return date ? date.split("T")[0] : "-";
    },
    applyQuickDateFilter() {
      this.filters.date_from = '';
      this.filters.date_to = '';
      this.fetchOrders();
    },
    showConfirmation() {
      this.showPopup = true;
    },
    cancel() {
      this.printPopup = false
      this.packing_admin = null
      this.wait_for_submit = false
    },
    confirmAction() {
      this.showPopup = false;
      this.printPopup = false;
      this.changeToShipped();
    },
    changeToShipped() {
      let date_object =  {
        to_id: this.toId,
        from_id: this.fromId,
      }
      if (this.filters.is_printed !== 'all') {
        date_object.is_printed = this.filters.is_printed
      }
      if (this.filters.is_torob !== 'all') {
        date_object.is_torob = this.filters.is_torob
      }
      if (this.filters.id) {
        date_object.id = this.filters.id
      }
      if (this.filters.date) {
        date_object.date = this.filters.date
      }

      this.request({
        url: this.endpoint('shop/bulkChangeToProcessingStatus'),
        method: "post",
        data : date_object ,
        success: data => {
          this.showNotificationMessage(`  سفارش ها با موفقیت به درحال بسته بندی رفت `, 'success');
          this.resetFilters()
          this.packing_admin = null
          this.wait_for_submit = false
        }
      })
    }


  },
  mounted() {
    this.fetchOrders(1);
  }
};
</script>

<style scoped>
table th,
table td {
  text-align: right;
}
</style>

